<template>
  <b-form-group>
    <b-form-radio-group
      v-if="displayTag === displayTagOption.RADIO"
      class="information-radio-group mt-2 px-2"
      button-variant="outline-primary"
      v-model="selected"
      :options="sensorInformationOptions"
    />
    <label
      v-if="displayTag === displayTagOption.SELECT"
      class="mt-2 px-2"
    >
      {{ $t('sensors.actions.select-module') }}
    </label>
    <s-select
      v-if="displayTag === displayTagOption.SELECT"
      class="mt-2 px-2"
      v-model="selected"
      :options="sensorInformationOptions"
    />
  </b-form-group>
</template>

<script>
import { DisplayTypeComponentizedModule } from 'sigma-mappings';

export default {
  name: 'GroupComponentizedModule',
  props: {
    selectedInformation: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    sensorInformationOptions() {
      const sensorInformationOptions = [];
      const options = (this.options || []).filter(({ information }) => !!information);

      if (!options.length) {
        return sensorInformationOptions;
      }

      options.forEach((option) => {
        sensorInformationOptions.push({
          text: option.information,
          value: option.assetModuleId,
          disabled: false,
        });
      });

      return sensorInformationOptions;
    },

    displayTag() {
      const options = (this.options || []).filter(({ displayTag }) => !!displayTag);
      if (!options.length) {
        return DisplayTypeComponentizedModule.RADIO;
      }

      return options[0].displayTag;
    },

    displayTagOption() {
      return DisplayTypeComponentizedModule;
    },

    selected: {
      get() {
        return this.selectedInformation.assetModuleId;
      },
      set(value) {
        const [filtered] = (this.options || []).filter(item => item.assetModuleId === value);
        this.$emit('on-change-selected-information', filtered);
      },
    },
  },
};
</script>
